import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ExtensionsNewRequestStore } from '../stores/lenderExtensionNewRequestStore'

export const useExtensionsNewRequestStore = () =>
  useContext<{
    extensionsNewRequestStore: ExtensionsNewRequestStore;
  }>(StoreContext);
